export default "__VITE_ASSET__DeUY26iP__"